/* ──────────────────────────────────────────────────────────────────────────
   Community landing page · behaviour
   ──────────────────────────────────────────────────────────────────────────
   Two jobs, both optional to the page working:

   1. Reveal. Elements marked [data-cm-reveal] fade up once when they first
      enter the viewport. The hidden state lives behind html.cm-js, which
      snippets/cm-tokens.liquid sets synchronously before paint, so the
      content is never painted and then hidden. Setting __cmCommunityInit
      tells that snippet's timeout that the script arrived.

   2. Rail. The photo marquee is paused whenever it is off screen, so a
      backgrounded tab is not compositing a row of images for nothing.

   The reveal runs on an IntersectionObserver plus a cheap sweep, and the
   sweep is the part that matters. An observer alone loses entries when the
   viewport jumps rather than scrolls, and this page jumps: both hero
   buttons are in-page anchors. Landing on a section whose copy is still at
   opacity 0 is the worst failure this pattern has, so the sweep reveals
   whatever is on screen however the visitor got there: anchor jump, back
   button, restored scroll position, or a fast flick on a phone.

   Anything this file does not get to still leaves a complete page: the CSS
   only hides content while html.cm-js is present, and the marquee runs
   from CSS alone.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  /* Five sections each render cm-tokens.liquid, so this file arrives as
     five identical <script src> tags. The browser fetches it once but runs
     it once per tag, which would mean five observers and five scroll
     listeners doing the same work. First one in wins. */
  if (window.__cmCommunityInit) return;
  window.__cmCommunityInit = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    var nodes = document.querySelectorAll('[data-cm-reveal]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  if (!('IntersectionObserver' in window)) {
    root.classList.remove('cm-js');
    return;
  }

  if (reduce) {
    revealAll();
  } else {
    var revealer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    document.querySelectorAll('[data-cm-reveal]').forEach(function (el) {
      revealer.observe(el);
    });

    /* The sweep. Cheap enough to run on every scroll frame: the selector
       only ever matches what is still hidden, so it empties out as the
       visitor moves down the page. */
    var queued = false;
    function sweep() {
      queued = false;
      var pending = document.querySelectorAll('[data-cm-reveal]:not(.is-in)');
      for (var i = 0; i < pending.length; i++) {
        var box = pending[i].getBoundingClientRect();
        if (box.top < window.innerHeight * 0.94 && box.bottom > 0) {
          pending[i].classList.add('is-in');
        }
      }
    }
    function queueSweep() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sweep);
    }

    window.addEventListener('scroll', queueSweep, { passive: true });
    window.addEventListener('resize', queueSweep, { passive: true });
    window.addEventListener('pageshow', queueSweep);
    document.addEventListener('visibilitychange', queueSweep);
    /* setTimeout rather than rAF: a hash jump can happen while the tab is
       backgrounded, where rAF never runs. */
    window.addEventListener('hashchange', function () { setTimeout(sweep, 60); });

    queueSweep();
    /* Belt and braces for a jump that lands before this file boots, for
       instance a link straight to /pages/community#cm-app. */
    setTimeout(sweep, 350);
  }

  var rails = document.querySelectorAll('.cm-rail');
  if (rails.length) {
    var railWatcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-paused', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    rails.forEach(function (rail) { railWatcher.observe(rail); });
  }
})();
